import { Content, NavController, Events, Platform, PopoverController } from 'ionic-angular';
import { ViewChild, Component, HostListener } from '@angular/core';
import { Validators, FormBuilder, FormGroup, FormControl } from '@angular/forms';

import { AuthenticateService } from '../../services/authenticateService';
import { LocalStorageService } from '../../services/local-storage';
import { AlertMessager } from '../../lib/alertMessager';
import { EventNames } from '../../lib/eventNames';
import { LoadingController } from 'ionic-angular';
import { SignUpPage } from './signup';
import { ViewController } from 'ionic-angular';
import { AccountHelper } from '../../lib/accountHelper';
import { UserService } from '../../services/user.service';

import { ForgotPasswordPage } from './forgot-password';
import { ResetPasswordPage } from './reset-password';
import { StaffPage } from '../staff/staff';

@Component({
    selector: 'page-login',
    templateUrl: 'index.html'
})
export class LoginPage {
    @ViewChild(Content) content: Content;

    emailAddress: string = '';
    password: string = '';

    signinForm: FormGroup;
    validationMessages: any[];

    passwordType: string = 'password';
    passwordIconType: string = 'eye';

    loggingIn: boolean;
    popoverActive: boolean;
    submitAttempt: boolean;

    constructor(public nav: NavController, private authenticateService: AuthenticateService, private events: Events, 
                private viewCtrl: ViewController, private alertMessager: AlertMessager, private loadingControl: LoadingController, private userService: UserService,
                private localStorage: LocalStorageService, private popoverController: PopoverController, private formBuilder: FormBuilder, private platform: Platform) {
        this.signinForm = this.formBuilder.group({
            email: new FormControl('email', Validators.compose([
                Validators.required,
                Validators.pattern('^[a-zA-Z0-9._]+[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$')
            ])),
            password: new FormControl('password',  Validators.required)
        });
            
        this.validationMessages = [
            { name: 'email', type: 'required', message: 'Email Address is required.' },
            { name: 'email', type: 'pattern', message: 'Your email address has an incorrect format.' },
            { name: 'password', type: 'required', message: 'Password is required.' },
        ];
    }

    @HostListener('body:keyup', ['$event'])
    _keyUp(event: KeyboardEvent) {
        if (event.keyCode === 13 && this.viewCtrl.isLast()) {
            this.signIn();
        }
    }

    showHide() {
        if (this.passwordType == 'text') {
            this.passwordType = 'password';
            this.passwordIconType = 'eye';
        }
        else {
            this.passwordType = 'text';
            this.passwordIconType = 'eye-off';
        }
    }
    
	signIn() {
        if (this.loggingIn)
            return;

        this.submitAttempt = true;

        if (!this.signinForm.valid)
            return;

        this.loggingIn = true;
        let loading = this.loadingControl.create({
            content: 'Logging you in...',
        });

        loading.present();
		this.authenticateService.authenticate(this.emailAddress, this.password)
		.then(data => {
            loading.dismiss();
            this.loggingIn = false;

            if ((data as any).errorMessage !== undefined) {
                this.alertMessager.showError("Login Error", (data as any).errorMessage);
            } else  if (data['id'] === 0) {
				this.alertMessager.showError('Login Error', 'The email or password provided is incorrect.');
			} else if ((data as any).newPasswordRequired) {
                if (this.popoverActive)
                    return;

                this.popoverActive = true;

                let popover = this.popoverController.create(ResetPasswordPage,{
                    emailAddress: this.emailAddress,
                    resetCode: this.password
                }, {
                    cssClass: 'page-forgot-password'
                });

                popover.present();

                popover.onDidDismiss((data) => {
                    this.popoverActive = false;
                })
            } else {
				this.localStorage.updateEntity('authtokens', data)
				.then(data => {
                    this.events.publish(EventNames.userLoggedIn);
                    AccountHelper.instance().loadToken(data);
                    this.userService.getUser(data.id);

                    this.nav.setRoot(StaffPage);
				});
			}
		}, error => {
            loading.dismiss();
            this.loggingIn = false;
            this.alertMessager.showError('Login Error', error);
        });
	}

    signUp() {
        this.nav.push(SignUpPage);
    }

    forgotPassword() {
        if (this.popoverActive)
            return;

        this.popoverActive = true;

        let popover = this.popoverController.create(ForgotPasswordPage, { }, {
            cssClass: 'page-forgot-password'
        });

        popover.present();

        popover.onDidDismiss((data) => {
            this.popoverActive = false;
        })
    }
}


// WEBPACK FOOTER //
// ./src/pages/login/index.ts